import ActionType from 'actions/ActionType'

export default (state = {}, action) => {
  switch (action.type) {
    // case ActionType.Data.LIST_SUCCESS:
    //   if (action.entityType === 'campaign') {

    //   }
    case ActionType.Campaign.LIST_CONTACTS_IN_STAGE_SUCCESS:
      return {
        ...state,
        [action.payload?.campaign_id]: {
          ...state?.[action.payload.campaign_id],
          [action.payload.stage_id]: [
            ...(state?.[action.payload.campaign_id]?.[
              action.payload?.stage_id
            ] || []),
            ...(action.payload?.contact_ids || []),
          ],
        },
      }
    case ActionType.Campaign.CLICK_CONTACT_COUNT:
      if (!action.payload) {
        return {}
      }
      return state
    default:
      return state
  }
}
